import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3bf675ef&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=3bf675ef&prod&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=3bf675ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf675ef",
  null
  
)

export default component.exports